module.exports = __webpack_public_path__ + "img/big-ball.23c81ccc.svg";